import { useState } from "react";

const useForm = (initialState = {}) => {
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});

  const reset = (newFormState = initialState) => {
    setValues(newFormState);
  };

  /**
   * It takes a target object and returns the value of the target object as a number, boolean, or string
   * @param target - The input element that was changed.
   * @returns the value of the input field.
   */
  const parseDataType = (target) => {
    if (target.type === "number") {
      return parseInt(target.value, 10) || "";
    }

    if (target.value === "true") {
      return true;
    }

    if (target.value === "false") {
      return false;
    }

    return target.value.toString();
  };

  const handleInputChange = ({ target }) => {
    const value = parseDataType(target);
    setValues({
      ...values,
      [target.name]: value,
    });
  };

  return [values, handleInputChange, errors, setErrors, reset];
};

export default useForm;
